import type { Device } from 'src/utils/api';
import qs from 'qs';
import { UI_ROUTES } from 'src/constants/routes/routes';
import { STRINGIFY_OPTIONS } from 'src/hooks/use-search/constant';

export const getDeviceZoneEditorPath = <T>(device: T extends Pick<Device, 'id' | 'name' | 'org'> ? T : never) => ({
  pathname: `${UI_ROUTES.ZONE_EDITOR}`,
  search: `?${qs.stringify(
    {
      device: {
        id: device.id,
        name: device.name,
        org: device.org,
      },
    },
    STRINGIFY_OPTIONS
  )}`,
});
